import { HttpResponseBase, HttpResponse, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Prospect } from 'src/app/model/Prospect';
import { PaymentModel, AccessoryInfo, DiscountInfo, DiscountValueType } from 'src/app/model/PaymentModel';
import { CustomerModel, AddressInfo, ContactMethods, ContactType, PreferredPhoneType, NextOfKinInfo, OfficeInfo } from 'src/app/model/CustomerModel';
import { ProductModel } from 'src/app/model/selfcareproducts';
import { AccountModel, SIMCardInfo } from 'src/app/model/AccountModel';
import { Payments } from 'src/app/model/Payments';

 
 
 

export class Utilities {

    public static readonly captionAndMessageSeparator = ':';
    public static readonly noNetworkMessageCaption = 'No Network';
    public static readonly noNetworkMessageDetail = 'The server cannot be reached';
    public static readonly accessDeniedMessageCaption = 'Access Denied!';
    public static readonly accessDeniedMessageDetail = '';
    public static getGetOption(): any {
        return {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            })
        };
    }
    public static getPostOption(content: any): any {
        return {
            body: content,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
            })
        };
    }
    /*public static baseUrl() {
        const base = environment.baseUrl;
        return base.replace(/\/$/, '');
    }*/

    public static getResponseBody(response: HttpResponseBase) {
        if (response instanceof HttpResponse) {
            return response.body;
        }
        if (response instanceof HttpErrorResponse) {
            return response.error || response.message || response.statusText;
        }
    }


    public static checkNoNetwork(response: HttpResponseBase) {
        if (response instanceof HttpResponseBase) {
            return response.status === 0;
        }

        return false;
    }

    public static checkAccessDenied(response: HttpResponseBase) {
        if (response instanceof HttpResponseBase) {
            return response.status === 403;
        }

        return false;
    }

    public static checkNotFound(response: HttpResponseBase) {
        if (response instanceof HttpResponseBase) {
            return response.status === 404;
        }

        return false;
    }

    public static checkIsLocalHost(url: string, base?: string) {
        if (url) {
            const location = new URL(url, base);
            return location.hostname === 'localhost' || location.hostname === '127.0.0.1';
        }

        return false;
    }



    public static getQueryParamsFromString(paramString: string) {

        if (!paramString) {
            return null;
        }

        const params: { [key: string]: string } = {};

        for (const param of paramString.split('&')) {
            const keyValue = Utilities.splitInTwo(param, '=');
            params[keyValue.firstPart] = keyValue.secondPart;
        }

        return params;
    }


    public static splitInTwo(text: string, separator: string): { firstPart: string, secondPart: string } {
        const separatorIndex = text.indexOf(separator);

        if (separatorIndex === -1) {
            return { firstPart: text, secondPart: null };
        }

        const part1 = text.substr(0, separatorIndex).trim();
        const part2 = text.substr(separatorIndex + 1).trim();

        return { firstPart: part1, secondPart: part2 };
    }

    public static JSonTryParse(value: string) {
        try {
            return JSON.parse(value);
        } catch (e) {
            if (value === 'undefined') {
                return void 0;
            }

            return value;
        }
    }
 
    public static  MapProspect(prospect: Prospect) : PaymentModel
    {
        let paymentModel = {} as PaymentModel;
        let customerModel = {} as CustomerModel;
        let nextOfKinInfo = {} as NextOfKinInfo;
        let officeInfo = {} as OfficeInfo;
        let productModel = {} as ProductModel;
         
        var   accountModelList: AccountModel[] = [];

        
        let accountModelOne = {} as AccountModel;
        let sIMCardInfo = {} as SIMCardInfo;
        let accessoryInfo = {} as AccessoryInfo;
        let discountInfo = {} as DiscountInfo;
        
        let accessoryInfo2 = {} as AccessoryInfo;
        var AccessoriesList : AccessoryInfo[] = [];

        
        // cust.address
        let addressInfo = {} as AddressInfo;
        addressInfo.Street  = prospect.AddressStreet;
        addressInfo.Area = prospect.AddressArea;
        addressInfo.City = prospect.AddressCity;
        addressInfo.Country = prospect.AddressCountry;
        addressInfo.State = prospect.AddressState;
        addressInfo.Zip = prospect.AddressZip;
    
        customerModel.Address = addressInfo;
        customerModel.Anniversary = prospect.Anniversary;

        
        let contactMethods = {} as  ContactMethods;
        contactMethods .Type = prospect.ContactMethod==("SMS") ? ContactType.SMS : prospect.ContactMethod==("Email") ? ContactType.Email : ContactType.Telephone;
        contactMethods.PreferredPhone = PreferredPhoneType.MobilePhone;
    
        customerModel.Address = addressInfo;

        customerModel.ContactMethod = contactMethods;

        customerModel.CreationDate = prospect.CreationDate,
        customerModel.CreatedDate = prospect.CreationDate,
        customerModel.DateOfBirth = prospect.DateOfBirth,
        customerModel.DealerID = prospect.DealerID;
        customerModel. DealerUserID = prospect.DealerUserID,
        customerModel. EmailAddress = prospect.EmailAddress,
        customerModel.  FirstName = prospect.FirstName,
        customerModel. Gender = prospect.Gender;
        customerModel. HomePhone = prospect.HomePhone;
        customerModel. i_customer = prospect.i_customer;
        customerModel. LastName = prospect.LastName;
        customerModel.KYCStatus = prospect.KYCStatus;
        customerModel. MiddleInitial = prospect.MiddleInitial,
        customerModel.MobilePhone = prospect.MobilePhone;

        nextOfKinInfo.Address = prospect.NokAddress;
        nextOfKinInfo.Name = prospect.NokName;
        nextOfKinInfo.Occupation = prospect.NokOccupation;
        nextOfKinInfo.Relationship = prospect.NokRelationship;
        nextOfKinInfo.Telephone = prospect.NokTelephone;
        customerModel.NextOfKin = nextOfKinInfo;    // Next of Kin relationship
        officeInfo.Address = prospect.OfficeAddress;
        officeInfo.Occupation = prospect.OfficeOccupation;
        officeInfo.Telephone = prospect.OfficeTelephone;
        customerModel.Office = officeInfo;

        customerModel.OperatorCode = prospect.OperatorCode,
        customerModel.PrimaryContact = prospect.PrimaryContact,
        customerModel.Salutation = prospect.Salutation,
        customerModel. SpouseName = prospect.SpouseName,
        customerModel.TIN = prospect.TIN,
        customerModel. ProspectID = prospect.ProspectID,
        customerModel. ReferralCode = prospect.ReferralCode,
        customerModel. ReferralActivationCode = prospect.ActivationCode,
        customerModel.FollowUp = prospect.FollowUp,   // == 1 ? true : false
        customerModel. CreatedBy = prospect.CreatedBy


        productModel.i_product = prospect.ProductID;
        paymentModel.Customer = customerModel;
        paymentModel.Product  = productModel;
        paymentModel.NoofDays = prospect.NoofDays;
        paymentModel.Amount = prospect.AmountPayable;
        paymentModel.CreditedAmount = prospect.AmountPaid;
        paymentModel. CreatedBy = prospect.CreatedBy

        sIMCardInfo.ICCID = prospect.SIMCode;
        accountModelOne.IPDevice = sIMCardInfo;
        accountModelList.push(accountModelOne);
        paymentModel.PaymentAccount = accountModelList;
    
        accessoryInfo.Name = prospect.Device1;
        accessoryInfo.Price = prospect.Device1Cost;
        accessoryInfo.Count = 1;

        accessoryInfo2.Name = prospect.Device2;
        accessoryInfo2.Price = prospect.Device2Cost;
        accessoryInfo2.Count = 1;

        discountInfo.Type = DiscountValueType.Actual;
        discountInfo.Value = 0;

        accessoryInfo.discountValue=discountInfo;
        accessoryInfo2.discountValue =discountInfo;
        AccessoriesList.push  (accessoryInfo);
        AccessoriesList.push  (accessoryInfo2);
        paymentModel.Accessories =   AccessoriesList;




        return paymentModel;

    }
   
 
 
    public static  MapPayment(model: PaymentModel) : Payments
    {
        var   desc :string = model.Description.split('-')[0];

        if (model.Description.includes("-"))
        {

             var Val :number = 0;
               Val=  parseInt( model.Description.split('-')[0]);
            if (Val > 0)
            {
                desc = model.Description.split('-')[1];
            }

        }

            let payments : Payments = {} as Payments;

           payments. AccountName = model.PaymentAccount != null && model.PaymentAccount.length > 0 && model.PaymentAccount[0].ID != null ? model.PaymentAccount[0].ID.split('@')[0] : "";
           payments.Agent = model.CreatedBy;
           payments. Amount = model.Amount;
           payments.CreditedAmount= model.CreditedAmount ? model.CreditedAmount : 0.00;
         
           payments .CustomerName = `${model.Customer.i_customer} - ${model.Customer.FirstName ? model.Customer.FirstName : ""} ${model.Customer.LastName ? model.Customer.LastName : ""}`;
           payments. Time = model.CreatedDate.toString( );
           payments.Description = desc;
           payments.   i_customer = model.Customer.i_customer;
     

           if (model.IsReversal  && model.IsReversal==true)
           {
            payments.IsReversed ="Yes";

           }
           else{
            payments.IsReversed ="No";

           }
           payments. Location = model.Location != null ? model.Location : "";

           payments.ProductName = model.Product != null && model.Product.Name != null ? model.Product.Name : "",
           payments. ReceiptNo = model.ReceiptNumber,
           payments. Category = model.Category,
           payments. Origin = model.Origin,
           payments.NoOfSubscriptions = model.NoofDays ? model.NoofDays : 1;
           payments.Date = model.CreatedDate.toString();





            return payments;
    } 

    

    

}